import React, { useEffect, useState } from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { usePositionService } from 'domain/shared/employee';
import { useTechnologyService } from 'domain/shared/career';

interface EmployeePositionWithSpecializationFieldProps extends FieldProps {
  positionIdValue?: Nullable<string>;
  specializationIdValue?: Nullable<string>;
  positionIdSource?: Nullable<string>;
  specializationIdSource?: Nullable<string>;
  label?: Nullable<string>;
  width?: string;
}

const EmployeePositionWithSpecializationField = ({
  positionIdValue: inputPositionIdValue = null,
  specializationIdValue: inputSpecializationIdValue = null,
  positionIdSource = null,
  specializationIdSource = null,
  label = null,
  width = '15%',
}: EmployeePositionWithSpecializationFieldProps) => {
  const { findAll: findAllPositions } = usePositionService();
  const { findAll: findAllTechnologies } = useTechnologyService();

  const { getValue: getPositionIdValue } = useFieldHelper({ value: inputPositionIdValue, source: positionIdSource });
  const { getValue: getSpecializationIdValue } = useFieldHelper({
    value: inputSpecializationIdValue,
    source: specializationIdSource,
  });

  const positionIdValue = inputPositionIdValue || (getPositionIdValue && getPositionIdValue());
  const specializationIdValue = inputSpecializationIdValue || (getSpecializationIdValue && getSpecializationIdValue());

  const [positionName, setPositionName] = useState<string>('');
  const [specializationName, setSpecializationName] = useState<string>('');

  useEffect(() => {
    (async () => {
      const positions = await findAllPositions();
      const specializations = await findAllTechnologies();

      const foundPosition = positions.find((position: any) => position.id === positionIdValue);
      const foundSpecialization = specializations.find(
        (specialization: any) => specialization.id === specializationIdValue,
      );

      setPositionName(foundPosition ? foundPosition.name : '');
      setSpecializationName(foundSpecialization ? foundSpecialization.name : '');
    })();
  }, [findAllPositions, findAllTechnologies, positionIdValue, specializationIdValue]);

  const value =
    specializationName !== '' && specializationName ? `${specializationName} ${positionName}` : positionName;

  return <TextField label={label} value={value} width={width} />;
};

export default EmployeePositionWithSpecializationField;
